<template>
  <div class="file-list">
    <div class="file-list__item" v-for="(item, index) in list" :key="`file-list-item-${index}`">
      <i class="el-icon-document" />

      <span class="file-list__item-name">{{ item.name }}</span>

      <div class="file-list__item-actions">
        <a
          v-if="item.link"
          :href="item.link"
          class="file-list__item-button"
        >
          <i class="el-icon-download" />
        </a>
        <button
          v-if="!readOnly"
          class="file-list__item-button"
          @click="removeItem(index)"
        >
          <i class="el-icon-close" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: {
        type: Array,
        default: () => ([])
      },

      readOnly: {
        type: Boolean,
        default: false,
      }
    },

    methods: {
      removeItem(index) {
        this.$emit('update:list', this.list.filter((_, idx) => idx !== index))
      }
    }
  }
</script>

<style lang="scss">
  .file-list {
    &__item {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      column-gap: 8px;
      width: 100%;
    }

    &__item-button {
      cursor: pointer;
      transition: .3s color;

      &:hover {
        color: $brand-clr-1;
      } 
    }

    &__item-name {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>